"use client";

import React from "react";
import { Globe } from "lucide-react";

const AddressAndLanguage: React.FC = () => {
  const [selectedLang, setSelectedLang] = React.useState("en");

  const changeLanguage = (lang: string) => {
    setSelectedLang(lang);
    const selectField = document.querySelector(
      ".goog-te-combo"
    ) as HTMLSelectElement;
    if (selectField) {
      selectField.value = lang;
      selectField.dispatchEvent(new Event("change"));
    }
  };

  return (
    <label
      title="Change language"
      className="relative flex size-9 cursor-pointer items-center justify-center rounded-full border border-gray-300 bg-white text-gray-600 shadow-sm transition-colors hover:border-red-500 hover:text-red-600 focus-within:ring-2 focus-within:ring-red-500"
    >
      <Globe aria-hidden="true" className="size-4" />
      <select
        aria-label="Change language"
        value={selectedLang}
        onChange={(e) => changeLanguage(e.target.value)}
        className="absolute inset-0 size-full cursor-pointer opacity-0"
      >
        <option className="notranslate" value="en">EN</option>
        <option className="notranslate" value="ar">AR</option>
        <option className="notranslate" value="hi">HI</option>
      </select>
    </label>
  );
};

export default AddressAndLanguage;